export interface CommonProjectType {
    project_id?: number;
    job_number?: string;
    project_type?: 'CP' | 'DP' | undefined;
    description?: string;
    status?: 'Current' | 'Ongoing' | 'Completed' | undefined;
    address?: string;
}


// to single object maping
export const mapCommonProjectType = (data: any): CommonProjectType => {
    if (!data) {
        throw new Error('Invalid Projects')
    }

    const contact: CommonProjectType = {
        project_id: data.project_id,
        job_number: data.job_number,
        project_type: data.project_type,
        description: data.description,
        status: data.status,
        address: data.full_address,
    }

    return contact;
}

// maping list objects
export const mapCommonProjectTypes = (data: any[]): CommonProjectType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Contacts');
    }
    return data.map(mapCommonProjectType);
}

